export class HelpFeaturesDialogInput {
}

export class HelpFeaturesDialogResult {
    constructor(public confirmed: boolean) {}
}
